import { Component, OnInit } from '@angular/core';
import { SettingsService} from '../../services/settings.service';
import { HomeService} from '../../services/home.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  stateUser: number = 0;

  selectedItem: number = 0;
  selectedItemID: number = 0;
  itemName: string = "";
  newItemName: string = '';
  newPostName: string = '';
  editedPost: boolean = false;
  editedItem: number = -1;
  editedItemID: string = '';
  isAddedItem: boolean = false;
  //project: projectType;

  orderedProjectItem = -1;
  
  editedProject = {
    id: "",
    settings: 0,
    idUser: localStorage.getItem("idUser"),
  };

  constructor(private settingsService: SettingsService, private homeService: HomeService) { }

  ngOnInit() {
    this.stateUser = Number(localStorage.getItem("stateUser"));
    if(this.stateUser == 0){
      this.settingsService.isFirst = true;
    }
    else{
      this.settingsService.isFirst = false;

    }
    this.homeService.idProject = "UL" + localStorage.getItem("idUser").slice(-20);
    this.homeService.getProject();
  }

  initData(){
    this.settingsService.initData();
    this.stateUser = Number(localStorage.getItem("stateUser"));

  }
  incState(){
    this.settingsService.incState();
    this.stateUser = Number(localStorage.getItem("stateUser"));

  }

  selectItem(i, itemID){
    this.selectedItem = i;
    this.selectedItemID = itemID;
  }

  addItem(){
    this.homeService.addItem(this.itemName);
    this.itemName = "";
  }
  editItem(i){
    this.editedItem = i;
    this.itemName = this.homeService.project.items[i].title;
  }
  updateItem(){
    this.homeService.updateItemName(this.editedItem, this.itemName);
    this.editedItem = -1;
    this.itemName = "";
  }
  toggleCheckbox(i){
    this.homeService.toggleCheckbox(i);
  }

  removeItem(i, id){
    this.homeService.removeItem(i, id);
  }

  updateNote(){
    this.homeService.updateNote(this.newPostName);
    this.editedPost = false;

  }

  editProject(){
    this.editedProject.id = this.homeService.project.id;
    this.editedProject.settings = this.homeService.project.settings;
  }

  updateProject(){
    this.homeService.updateProject(this.editedProject);
    this.itemName = "";
  }

  editNote(){
    this.newPostName = this.homeService.project.note;
    this.editedPost = true;
  }

  dropSuccess(i){
    this.orderedProjectItem = -1;
    this.homeService.changeOrder(i+1);
  }

  dragStart(i){
    this.orderedProjectItem = i;
  }

  dragEnd(){
    this.orderedProjectItem = -1;
  }

  orderUp(i){
    this.homeService.orderUp(i);
  }
  orderDown(i){
    this.homeService.orderDown(i);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts